export default {
    Today: "اليوم",
    Tomorrow: "غداً",
    LiveRadioGuide: "دليل البث الرياضي المباشر",
    LiveTvGuide: "دليل البث التلفزيوني المباشر",
    LiveSportGuide: "دليل البث الرياضي المباشر",
    Channel: "القنوات",
    More: "المزيد",
}